<template>
  <div>
    <span class="trace">...base/Card.vue {{ title }}  ~{{ height }} |{{ graphic }}|</span>
    <!--       @click="$emit('click')"  "alertFn('click')"
    -->
    <v-card
      :height="height"
      :width="width"
      class="mb-4"
      flat
      tile
      v-bind="$attrs"
      v-on="$listeners"
      @click="$emit('click')"
    >
      <slot />
    </v-card>
    <!--
    -->
    <base-title
      v-if="title"
      :title="title"
      size="subtitle-1"
      space="0"
      class="text-uppercase"
    />

    <base-subtitle
      v-if="subtitle"
      :title="subtitle"
    />
  </div>
</template>

<script>
  export default {
    name: 'BaseCard',

    inheritAttrs: false,

    props: {
      height: [Number, String],
      width: [Number, String],
      subtitle: String,
      title: String,
      graphic: String,
    },

    methods: {
      alertFn: function (arg) {
        console.log(arg)
      },
    },

  }
</script>
